export const optionsTypesInmuebles = [
    {value:"Departamento", label:"Departamento"},
    {value:"Oficinas", label:"Oficinas"},
    {value:"Casa", label:"Casa"},
    {value:"Airbnb", label:"Airbnb"},
    {value:"Locales", label:"Locales"},
];